import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
// import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";
import { useDispatch } from "react-redux";
import { post_site_data } from "http/components/SiteData";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setHomeData } from "../../../../../Redux/slices/mngrSlice";

export default function AddHomeData() {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    title: {
      label: "Title",
      type: "text",
      multiLine: false,
      placeholder: "Enter title",
      value: "",
      validation: false,
    },
    // language: {
    //   label: "Language",
    //   type: "radio",
    //   value: { key: "English", value: "en" },
    //   items: [
    //     { key: "English", value: "en" },
    //     { key: "France", value: "fr" },
    //     { key: "Italy", value: "it" },
    //   ],
    // },
    text: {
      label: "Text",
      type: "text",
      multiLine: true,
      placeholder: "Enter text",
      value: "",
      validation: false,
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ title: { value: "", validation: false } });
    // setControls({ language: { value: { key: "English", value: "en" } } });
    setControls({ text: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  // const onChangeRadio = (name, value) => {
  //   setControls({ [name]: { value: value } });
  // };

  const onSubmit = async () => {
    const { title, text } = controls;
    if (title.validation) {
      dispatch(HandleLoading(true));
      const response = await post_site_data({
        title: title.value,
        body: text.value,
        section: "home",
      });
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setHomeData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={{ xs: 12 }} key={key + index}>
            {controls[key].type === "text" && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
            {/* {controls[key].type === "radio" && (
              <MuiRadioGroup
                name={key}
                label={controls[key].label}
                items={controls[key].items}
                value={controls[key].value}
                onChange={onChangeRadio}
              />
            )} */}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
